export const NoContentBlockDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type NoContentBlockDirection =
  (typeof NoContentBlockDirection)[keyof typeof NoContentBlockDirection]

export const NoContentBlockJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type NoContentBlockJustifyContent =
  (typeof NoContentBlockJustifyContent)[keyof typeof NoContentBlockJustifyContent]

export const NoContentBlockAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
} as const
export type NoContentBlockAlignItems =
  (typeof NoContentBlockAlignItems)[keyof typeof NoContentBlockAlignItems]
